<template>
    <dash
        icon="fa fa-calendar"
        titulo="CONTRATAÇÕES VENCENDO ENTRE 14 E 7 DIAS"
        :qtd="qtd"
        :loading="loading"
        color="#ff4040"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
